import { useLingui } from '@lingui/react/macro'
import type { ReactElement } from 'react'

import { LotoPresetCombobox } from './LotoPresetCombobox'

export function LotoPointPositionCombobox({
  tag,
  value,
  onChange,
}: {
  tag: string
  value: string
  onChange: (value: string) => void
}): ReactElement {
  const { t } = useLingui()
  const positionOptions = [
    t({ message: 'Closed', context: 'LOTO isolation position' }),
    t({ message: 'Open', context: 'LOTO isolation position' }),
  ]
  return (
    <LotoPresetCombobox
      label={t`Position for ${tag}`}
      clearLabel={t`Clear position for ${tag}`}
      placeholder={t`Position`}
      value={value}
      options={positionOptions}
      onChange={onChange}
    />
  )
}
